export const MARITAL_STATUS_LIST_REQUEST = "MARITAL_STATUS_LIST_REQUEST"
export const MARITAL_STATUS_LIST_SUCCESS = "MARITAL_STATUS_LIST_SUCCESS"
export const MARITAL_STATUS_LIST_FAIL = "MARITAL_STATUS_LIST_FAIL"
export const MARITAL_STATUS_LIST_RESET = "MARITAL_STATUS_LIST_RESET"